import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EmailRegisterForm = ({ email, setEmail, handleRegister, messageClass, messageRef, emailInputRef }) => {
    const navigate = useNavigate();

    return (
        <>
            <h2>
                <span className="titleIcon"><FontAwesomeIcon icon="user-plus" /></span>&nbsp;Create Account
            </h2>
            <div ref={messageRef} className={messageClass} id="message"></div>

            <form onSubmit={(e) => handleRegister(e, messageRef, emailInputRef)}>
                <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    ref={emailInputRef}
                    title="Enter your email"
                />
                <button type="submit" id="register-button" className="login-button">
                    Register
                </button>
            </form>

            <div className="register-box">
                <p>Already have an account?</p>
                <button className="register-button" id="login-button" onClick={() => navigate("/login")}>
                    Log In
                </button>
            </div>
        </>
    );
};

export default EmailRegisterForm;